<div class="finance-values-set">
  <div class="bottom-table-head">
    <h4>Finance Details</h4>
    <div class="amount-set">
      <div>
        Total Fund
        <span class="t-fund"
          >{{ totalFunds | currency : "INR" : "symbol" : "1.0-0" }}/-</span
        >
      </div>
      <div>
        Total Expenses
        <span class="t-expenses"
          >{{ totalExpenses | currency : "INR" : "symbol" : "1.0-0" }}/-</span
        >
      </div>
      <div>
        Remaining Balance
        <span class="t-balance"
          >{{ remainingBalance | currency : "INR" : "symbol" : "1.0-0" }}/-</span
        >
      </div>
      <p-button
        label="Add Expense"
        (click)="financeSidebarVisible = true; isAdd = true; FinanceForm.reset()"
        *appHasRole="[3]"
      />
    </div>
  </div>
 
</div>

<div class="justify-content-start flex-wrap mt-15">
  <p-table [value]="showTransaction" class="tab-data-table">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="Date">Date <p-sortIcon field="Date" /></th>
        <th pSortableColumn="Expense">
          Expense Type <p-sortIcon field="Expense" />
        </th>

        <th pSortableColumn="Amount">Amount <p-sortIcon field="Amount" /></th>
        <th pSortableColumn="Spent">Spent By <p-sortIcon field="Spent" /></th>
        <th pSortableColumn="Paid">Paid to <p-sortIcon field="Paid" /></th>
        <th pSortableColumn="Payment">
          Mode of Payment (Cash / Online)<p-sortIcon field="Payment" />
        </th>
        <th pSortableColumn="Approved">
          Approved By <p-sortIcon field="Approved" />
        </th>
        <th pSortableColumn="Description">
          Description <p-sortIcon field="Description" />
        </th>
        <th pSortableColumn="Bill">Bill Proofs <p-sortIcon field="Bill" /></th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-showTransaction>
      <tr>
        <td>{{ showTransaction.transactionDate | date : "dd-MM-YYYY" }}</td>
        <td>{{ showTransaction.expenseType }}</td>
        <td>
          {{
            showTransaction.transactionAmount
              | currency : "INR" : "symbol" : "1.0-0"
          }}
        </td>
        <td>{{ showTransaction.spentBy }}</td>
        <td>{{ showTransaction.paidTo }}</td>
        <td>{{ showTransaction.paymentMode }}</td>
        <td>{{ showTransaction.approvedBy }}</td>
        <td>{{ showTransaction.description }}</td>
        <td>{{ showTransaction.billProofs }}</td>
        <td class="text-center block">
          <div class="d-flex gap-3 action-btns">
            <img src="assets/images/icon-edit.svg" (click)="onEditTransaction(showTransaction)" *appHasRole="[3]">
            <img src="assets/images/icon-delete.svg" (click)="onDeleteTransaction(showTransaction)" *appHasRole="[3]">
          </div>

          
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-sidebar
  [(visible)]="financeSidebarVisible"
  position="right"
  [showCloseIcon]="false"
>
  <form
    [formGroup]="FinanceForm"
    *ngIf="financeSidebarVisible"
    (ngSubmit)="updateFinanceDetails()"
  >
    <div class="tab-pop-txt">
      <h4>{{ isAdd ? "Add" : "Update" }} Expense</h4>
      <i class="pi pi-times" (click)="financeSidebarVisible = false"></i>
    </div>
    <div class="pop-data-set">
      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Date</div>
        <div class="project-detail-set-v mt-2">
          <p-calendar formControlName="financeDate" id="financeDate" />

          <!-- <input
            pInputText
            id="financeDate"
            formControlName="financeDate"
            aria-describedby="financeDate"
          /> -->
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Expense Type</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="ExpenseType"
            formControlName="financeExpenseType"
            aria-describedby="ExpenseType"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Amount</div>
        <div class="project-detail-set-v mt-2">
          <p-inputNumber
            id="financeAmount"
            mode="decimal"
            formControlName="financeAmount"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Spent By</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="SpentBy"
            formControlName="financeSpentBy"
            aria-describedby="SpentBy"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Paid to</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="financePaidto"
            formControlName="financePaidto"
            aria-describedby="financePaidto"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Mode of Payment</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="financeModeofPayment"
            formControlName="financeModeofPayment"
            aria-describedby="financeModeofPayment"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Approved By</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="financeApprovedBy"
            formControlName="financeApprovedBy"
            aria-describedby="financeApprovedBy"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Description</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="financeDescription"
            formControlName="financeDescription"
            aria-describedby="financeDescription"
          />
        </div>
      </div>

      <div class="project-detail-set mt-4">
        <div class="project-detail-set-h">Bill Proofs</div>
        <div class="project-detail-set-v mt-2">
          <input
            pInputText
            id="financeBillProofs"
            formControlName="financeBillProofs"
            aria-describedby="financeBillProofs"
          />
          <p-fileUpload
            mode="basic"
            chooseLabel="Choose"
            chooseIcon="pi pi-upload"
            name="demo[]"
            url=""
            accept="image/*"
            maxFileSize="1000000"
            (onUpload)="onUpload($event)"
          />
        </div>
      </div>
    </div>

    <div class="tab-footer-btns">
      <p-button
        label="Cancel "
        (click)="financeSidebarVisible = false; isAdd = false"
        class="cancel-btn"
      />
      <p-button
        [label]="isAdd ? 'Add' : 'Update'"
        [disabled]="!FinanceForm.valid"
        type="submit"
        class="submit-btn"
        (click)="addExpence()"
      />
    </div>
  </form>
</p-sidebar>
